module.exports = __webpack_public_path__ + "static/img/PC-3.dedd399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-3.png
// module id = MBUM
// module chunks = 0